import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Box, CardMedia } from "@mui/material";
import { useState } from "react";
import Smiley from "../../assets/smiley";

export default function IntroInfoCard() {
  const [themeColor, setColor] = useState("#00E0DA");
  return (
    <div className="md:mx-8 flex items-center justify-center flex-col md:flex-row">
      <Card
        variant="rounded"
        sx={{
          width: { xs: "90%", sm: "40%", md: "40%" },
          borderRadius: 12,
          borderColor: "#2D2D2D",
          borderWidth: 2,
          bgcolor: "transparent",
          margin: 1,
          height: "22vw",
          overflow: "clip",
          minHeight: "170px",
        }}
        className="group"
        onMouseEnter={() => setColor("#FF4A4A")}
        onMouseLeave={() => setColor("#00E0DA")}
      >
        <CardContent sx={{ p: 0, height: "100%", "&:last-child": { pb: 0 } }}>
          <Box sx={{ display: "flex", height: "100%" }}>
            <Box
              sx={{
                width: "50%",
                height: "100%",
                bgcolor: "transparent",
                borderRightWidth: 2,
                borderColor: "#2D2D2D",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
              }}
            >
              <Typography
                sx={{
                  fontSize: { md: "1vw", xs: 7 },
                  color: "#9F9F9F",
                  padding: { md: 3, xs: 2 },
                  textAlign: "left",
                  fontFamily: "HelNeu-Med",
                }}
              >
                We don't just make bottle caps — we seal your brand's essence
                with precision and quality, delivering custom packaging
                solutions that elevate your product
              </Typography>
              <Box sx={{ display: "flex", paddingX: 2 }}>
                <Smiley fillColor={themeColor} />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 2,
                  }}
                >
                  <Typography
                    variant="title"
                    sx={{
                      fontSize: { md: "1.4vw", xs: 10 },
                      color: "#575757",
                      fontFamily: "HelNeu-Med",
                      textAlign: "left",
                    }}
                  >
                    Economic Caping Solutions
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: "50%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  height: "50%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  bgcolor: "transparent",
                  borderBottomWidth: 2,
                  borderBottomColor: "#2D2D2D",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { md: "3vw", sm: "14px" },
                    color: "#00E0DA",
                    paddingX: 2,
                    lineHeight: 0.8,
                    textAlign: "left",
                    fontFamily: "HelNeu-Light",
                  }}
                  className="duration-500 group-hover:text-[#FF4A4A]"
                >
                  PET
                </Typography>
                <Typography
                  sx={{
                    fontSize: { md: "1.6vw", sm: "12px" },
                    color: "#4D4D4D",
                    paddingX: 2,

                    textAlign: "left",
                    fontFamily: "HelNeu-Light",
                    lineHeight: 1,
                  }}
                >
                  Welcome to the Future of Bottle Enclosures
                </Typography>
              </Box>
              <Box
                sx={{
                  height: "50%",
                  bgcolor: "transparent",
                  display: "flex",
                  flexDirection: "row",
                  padding: { sm: 0, md: 2 },
                }}
                className="justify-center"
              >
                <img
                  src={
                    themeColor === "#00E0DA"
                      ? "/images/wheatLeft-cropped.svg"
                      : "/images/wheatLeftRed.svg"
                  }
                  alt="design element"
                  className="py-2 pl-1"
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-evenly",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#e5e5e5",
                      fontFamily: "HelNeu-Med",
                      fontSize: { xs: "2vw", md: "1.6vw" },
                      lineHeight: 0.9,
                    }}
                  >
                    Expert
                  </Typography>
                  <Typography
                    sx={{
                      color: "#4f4f4f",
                      fontSize: { xs: "1.7vw", md: "1.1vw" },
                    }}
                  >
                    COSIDICI
                    <br /> Award Winner
                  </Typography>
                </Box>
                <img
                  src={
                    themeColor === "#00E0DA"
                      ? "/images/wheatRight-cropped.svg"
                      : "/images/wheatRightRed.svg"
                  }
                  alt="design element"
                  className="py-2 pl-1"
                />
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>

      <Card
        variant="outlined"
        sx={{
          width: { xs: "90%", sm: "40%", md: "40%" },

          backgroundColor: "transparent",
          borderWidth: 0,
          margin: 2,
        }}
      >
        <CardMedia
          component="img"
          height="140"
          image="/images/homeImage.png"
          alt="Bottle caps"
        />
      </Card>
    </div>
  );
}
